import { showDialogWithData } from "../../../redux/guest-slices/other.slice"
import { retrieveAllMember } from "../../../redux/admin-slices/member.slice"
import TablePagination from "../../../components/common/PaginationSkell"
import EntriesSelect from "../../../components/ui/EntriesSelect"
import TableSkell from "../../../components/common/TableSkell"
import { DISABLE_USER_STATUS } from "../../../utils/keywords"
import SelectInputA from "../../../components/ui/SelectInputA"
import InputFieldA from "../../../components/ui/InputFieldA"
import UserServices from "../../../services/user.service"
import { useDispatch, useSelector } from "react-redux"
import { useState, useEffect, useRef } from "react"
import { debounce } from "../../../utils/helper"
import ActionMenu from "./ActionMenu"
import moment from "moment"


import {
  Avatar, Box, Container, Grid2 as Grid, Table, TableBody,
  TableCell, TableContainer, TableHead, TableRow, Typography,
} from "@mui/material"

function AllMembers() {
  const dispatch = useDispatch()
  const searchRef = useRef("")
  const statusRef = useRef("")
  const entriesRef = useRef("")
  const [data, setData] = useState(null)
  const userServices = new UserServices(dispatch)
  const [activeIndex, setActiveIndex] = useState(null)
  const { loadings, refresh } = useSelector((state) => state.otherSlice)

  // Gandle retrieve all Members
  const handleRetrieveAll = (filters) => {
    dispatch(
      retrieveAllMember({
        search: searchRef?.current?.value || null,
        limit: entriesRef?.current?.value || null,
        currentPage: filters?.currentPage || null,
        status: statusRef?.current?.value?.value || null,
      })
    )
      .unwrap()
      .then((data) => {
        setData(data)
      })
      .catch(() => { })
  }

  const handleSearch = debounce(() => {
    handleRetrieveAll()
  }, 1000)

  const handleToggleActiveStatus = async (id, status) => {
    if (!status) {
      dispatch(
        showDialogWithData({
          type: DISABLE_USER_STATUS,
          data: { memberId: id, status },
        })
      )
      return
    }

    const { success } = await userServices.enableUser({ id })
    if (success) handleRetrieveAll()
  }


  useEffect(() => {
    handleRetrieveAll()
    // eslint-disable-next-line
  }, [refresh])
  return (
    <Container maxWidth={false} fixed sx={{ py: 5 }}>
      <Box className="overview-container">
        <Typography variant="pageTitle">Members</Typography>
      </Box>

      <Grid
        container
        spacing={1}
        className="filters-grid"
        justifyContent="space-between"
      >
        <Grid size={{ xs: 12, lg: "auto" }} sx={{ minWidth: { xl: 350 } }}>
          <InputFieldA
            placeholder={"Search..."}
            label="Search"
            ref={searchRef}
            onChangeFun={handleSearch}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: "auto" }}>
          <EntriesSelect
            inputRef={entriesRef}
            label="Entries per page"
            onChange={() => {
              setTimeout(() => {
                handleRetrieveAll()
              }, 0)
            }}
          />
        </Grid>
      </Grid>

      <Box className="content-listing">
        <TableContainer className="adminTable1">
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {["Name", "Email", "Date", "Satus", "Action"]?.map(
                  (cell, i) => (
                    <TableCell key={i} align="left">
                      {cell}
                    </TableCell>
                  )
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {loadings?.retrieveAll ? (
                <TableSkell colLength={5} />
              ) : (
                data?.records?.map((user, i) => (
                  <TableRow
                    key={i}
                    tabIndex={-1}
                    role="checkbox"
                    sx={{
                      td: {
                        borderBottomWidth:
                          i === data?.records?.length - 1 ? "0" : "1px",
                      },
                    }}
                  >
                    <TableCell sx={{ textTransform: "capitalize" }}>
                      <Box
                        gap={1}
                        sx={{ display: "flex", alignItems: "center" }}
                      >
                        <Avatar src={user?.image} />
                        <Typography> {user?.fullName} </Typography>
                      </Box>
                    </TableCell>
                    <TableCell>{user?.email}</TableCell>

                    <TableCell>
                      {moment(user?.createdAt).format("MM-DD-YYYY HH:MM A")}
                    </TableCell>

                    <TableCell>
                      <SelectInputA
                        renderValueKey="name"
                        value={user?.status ?
                          { name: "Active", value: true } :
                          { name: "Blocked", value: false }
                        }
                        loading={loadings?.retrieveAll}
                        key={`${user?._id}-${user?.status}`}
                        onChange={(e) => {
                          handleToggleActiveStatus(user?._id, e?.target?.value?.value)
                        }}
                        options={[
                          { name: "Active", value: true },
                          { name: "Blocked", value: false },
                        ]}
                      />
                    </TableCell>

                    <TableCell>
                      <ActionMenu
                        index={i}
                        activeIndex={activeIndex}
                        setActiveIndex={setActiveIndex}
                        user={user}
                      />
                    </TableCell>
                  </TableRow>
                ))
              )}

              {!data?.records?.length && !loadings?.retrieveAll && (
                <TableRow sx={{ td: { borderBottom: "none" } }}>
                  <TableCell colSpan={5}>
                    <Typography variant="noRecords">
                      No results found!
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          cb={handleRetrieveAll}
          pagination={data?.pagination}
          length={data?.records?.length}
          loading={loadings?.retrieveAll}
        />
      </Box>
    </Container>
  )
}

export default AllMembers
